/**
 * @file Root Reducer 配置
 * @description 整合所有 slice reducers 為單一 root reducer
 */
import { combineReducers } from 'redux';
import loadingReducer from './slice/loadingSlice';
import globalReducer from './slice/globalOptionsSlice';

/**
 * Root Reducer
 * @description 組合所有 slice reducers
 * - loading: 控制全域載入狀態
 * - options: 管理全域選項設定
 */
const rootReducer = combineReducers({
  loading: loadingReducer,
  options: globalReducer
});

/** Root State 型別定義 */
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
